var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("h2", { staticClass: "c-games_gameListHeader_heading" }, [
    _c("span", { staticClass: "c-games_gameListHeader_title" }, [
      _vm._v("すべてのゲーム")
    ]),
    _vm._v(" "),
    !_vm.loading
      ? _c("span", { staticClass: "c-games_gameListHeader_gameCount" }, [
          _vm._v(_vm._s(_vm.appCount) + "タイトル")
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aadcf088", { render: render, staticRenderFns: staticRenderFns })
  }
}